// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalRegisterPhoto_root__29DwG","imageUpload":"ModalRegisterPhoto_imageUpload__1tA3Z","rotate":"ModalRegisterPhoto_rotate__3L50J"};